module.exports = __webpack_public_path__ + "static/code-snippet@2x-2c41dfc7454fc6935ffeded59fd93672.png";